import { Card, TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import { useState } from "react";
import { isAdministrator } from "../../utils/userRoleUtils";
import AdminSettings from "./adminSettings";
import AppLogManagement from "./appLogManagement";
import ChatConversationManagement from "./chatConversationManagement";
import CustomerManagement from "./customerManagement";
import ProductManagement from "./productManagement";
import RawSaleRecordManagement from "./rawSaleRecordManagement";
import UserManagement from "./userManagement";

const Admin: React.FC = () => {
    const [selectedTab, setSelectedTab] = useState(0);
    const userIsAdministrator = isAdministrator();
    if (!userIsAdministrator) {
        return <></>;
    }

    return (
        <TabStrip
            selected={selectedTab}
            onSelect={event => setSelectedTab(event.selected)}
            className="d-flex flex-column flex-grow-1 min-h-0 overflow-hidden m-1"
            tabContentStyle={{
                flex: "1 1 auto",
                minHeight: 0,
                overflowX: "hidden",
                overflowY: "auto"
            }}
        >
            <TabStripTab title="Logs">
                <Card>
                    <AppLogManagement />
                </Card>
            </TabStripTab>

            <TabStripTab title="Conversations">
                <Card>
                    <ChatConversationManagement />
                </Card>
            </TabStripTab>

            <TabStripTab title="Products">
                <Card>
                    <ProductManagement />
                </Card>
            </TabStripTab>
            <TabStripTab title="Raw Sales">
                <Card>
                    <RawSaleRecordManagement />
                </Card>
            </TabStripTab>
            <TabStripTab title="Customers">
                <Card>
                    <CustomerManagement />
                </Card>
            </TabStripTab>
            <TabStripTab title="Users">
                <Card>
                    <UserManagement />
                </Card>
            </TabStripTab>
            <TabStripTab title="Settings">
                <Card>
                    <AdminSettings />
                </Card>
            </TabStripTab>
        </TabStrip>
    );
};

export default Admin;
